/**
 * Shared Alberta ESA meal-break decision dialog (Aug 2026). Shown when the
 * server holds a 5h+ clock-out until the worker confirms their break status.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function MealBreakDialog({ open, shiftHours, thresholdHours, busy, onDeduct, onNoBreak, onCancel }) {
  if (!open) return null;
  const thr = thresholdHours || 5;
  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{ background: 'rgba(11,19,33,0.8)', backdropFilter: 'blur(4px)' }}
      data-testid="meal-break-dialog"
    >
      <div className="w-full max-w-sm rounded-2xl p-6" style={{ background: '#1A2433', border: '1px solid #2D3748' }}>
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(255,160,0,0.15)' }}>
            <AlertTriangle className="w-5 h-5" style={{ color: '#FFA000' }} />
          </div>
          <h3 className="text-lg font-semibold text-white">Did you take a meal break?</h3>
        </div>
        <p className="text-sm mb-5" style={{ color: '#A0AEC0' }}>
          You worked <span className="text-white font-semibold">{shiftHours ? `${shiftHours} hours` : `${thr}+ hours`}</span> without
          a logged meal break. Your company requires a 30-minute break for shifts of {thr} or more hours.
        </p>
        <div className="space-y-2">
          <button
            onClick={onDeduct}
            disabled={busy}
            className="w-full py-3 rounded-lg font-semibold transition-colors disabled:opacity-60"
            style={{ background: '#1E88E5', color: 'white' }}
            data-testid="meal-break-deduct-btn"
          >
            {busy ? 'Clocking out…' : 'Yes — deduct 30-min unpaid break'}
          </button>
          <button
            onClick={onNoBreak}
            disabled={busy}
            className="w-full py-3 rounded-lg font-semibold transition-colors disabled:opacity-60"
            style={{ background: '#2D3748', color: 'white' }}
            data-testid="meal-break-none-btn"
          >
            No — I didn't take a break
          </button>
          <button
            onClick={onCancel}
            disabled={busy}
            className="w-full py-2 rounded-lg text-sm font-medium"
            style={{ color: '#64748B' }}
            data-testid="meal-break-cancel-btn"
          >
            Cancel — stay clocked in
          </button>
        </div>
      </div>
    </div>
  );
}
